import styled from "@emotion/styled";

export const ViewControls = styled.div`
  display: flex;
  gap: 4px;

  padding-inline: 4px;
`;
